import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import "./switchTab.scss";

type SwitchTabComponentProps = {
    tab: "list" | "map";
    openList: () => void;
    openMap: () => void;
};

export const SwitchTabComponent = ({
    tab,
    openList,
    openMap,
}: SwitchTabComponentProps) => {
    const { t } = useGranite();

    return (
        <div role="group" className={"btn-group store-search-switch-tab"}>
            <Button
                type={"button"}
                color={tab === "list" ? "gray" : "transparent"}
                onClick={openList}
                aria-label={t("accessibility.searchStore.listTabButton")}
                className={"store-search-switch-tab__button"}
            >
                <i className="las la-list-ul la-lg"></i>
            </Button>
            <Button
                type={"button"}
                color={tab === "map" ? "gray" : "transparent"}
                onClick={openMap}
                aria-label={t("accessibility.searchStore.mapTabButton")}
                className={"store-search-switch-tab__button"}
            >
                <i className="las la-map-marked-alt la-lg"></i>
            </Button>
        </div>
    );
};
